import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { safeSourceUrl } from "./verification-source-url";

/** Older or manually entered events may lack a source URL. Never render an
 * arbitrary URI scheme as an actionable verification link. */
export function VerificationSourceLink({
  sourceUrl,
  label = "View verification source",
  showHost = false,
}: {
  sourceUrl: unknown;
  label?: string;
  showHost?: boolean;
}) {
  const href = safeSourceUrl(sourceUrl);
  if (!href) {
    return null;
  }

  return (
    <Button
      asChild
      variant="surface"
      size="sm"
      className={
        showHost
          ? "h-auto max-w-full justify-start gap-2 whitespace-normal py-2 text-left text-xs"
          : "gap-1.5"
      }
    >
      <a href={href} target="_blank" rel="noopener noreferrer">
        <ExternalLink
          className={showHost ? "size-3 shrink-0" : "size-4 shrink-0"}
          aria-hidden="true"
        />
        <span className="min-w-0 break-words">
          {label}
          {showHost && (
            <span className="block font-normal text-muted-foreground">
              {new URL(href).host}
            </span>
          )}
        </span>
      </a>
    </Button>
  );
}
